<template>
  <div class="creditorView_warpper">
    <nav-bar titleText="债权人" rigthFontColor="#F9591B" titleWeight="bold" rightWeight="bold" rightSize="18px"
      @goBack="goBack" :rightText="navBarRightText" @rightTextEvent=applyDebt></nav-bar>
    <div class="contentBox">
      <div class="contentBox-box">
        <div class="left-img">
          <img :src="!info.member_avator ? agentimg : info.member_avator" alt />
        </div>
        <div class="right">
          <div class="title">{{info.member_name}}</div>
          <div class="desc">{{info.member_mobile}}</div>
        </div>
      </div>
    </div>
    <div class="creditor-first-fiv">
      <div class="creditor-contact-service" v-if="list.length != 0" @click="chat">
        <span>遇到问题？</span>
        <span>联系客服，为您解答</span>
        <img src="../../../assets/debtor/right-arrow.png" alt="">
      </div>
      <p class="debt-order-title" v-if="list.length != 0">解债订单</p>
      <div class="refresh-btn" @click="refreshList">
        <img :src="reloadgrayicon" alt="">
      </div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" :style="pullStyle">
      <van-list v-model="loading" :finished="finished" :finished-text="this.list.length === 0 ? '' : '没有更多了'"
        @load="onLoad">
        <van-cell class="lists" v-for="(item, index) in list" :key="index">
          <div class="dataBody" @click="handleCreditor(item)">
            <div class="debtor_information">
              <div class="status-box">
                <div :class="[['待合同签名','待债权人确认'].includes(item.status) ? 'color_org' : 'color_999']">{{item.status}}
                </div>
                <div class="status-box-right" v-if="item.status == '待债权人确认'" @click="handleCreditor(item)">
                  <span>去确认</span>
                </div>
              </div>

              <!-- <div class="creditorsIcon" v-if="item.dtl && item.dtl.member_logo"> -->
              <div class="creditorsIcon">
                <img :src="!item.dtl.member_logo ? agentimg : item.dtl.member_logo" width="24" height="24" alt />
              </div>
              <div class="creditorsName">{{item.debtor_name || item.dtl.member_realname}}</div>
              <div class="clearBoth">
                <p class="solutionMoney" v-if="! item._showProgress">解债金额</p>
                <p class="solutionMoney" v-if="item._showProgress">已还金额·{{ item.repayment_period }}/36期</p>

                <p class="creditorsMoney" v-if="item._showProgress">￥{{ item.repayment_money }}</p>
                <p class="creditorsMoney" v-if="! item._showProgress">￥{{ item.amount }}</p>
                <!-- debt_amount -->
              </div>
              <van-progress v-if="item._showProgress && parseInt(item.repayment_period) > 0" color="#f9591b"
                :percentage="item.percentage" :show-pivot="false" track-color="#FEEEE8" />

              <p class="agent">经纪人代码 {{item.agent_code}}</p>
            </div>
          </div>
        </van-cell>

        <div class="empty" v-if="list.length === 0">
          <div class="emptyMsg" span="24">
            <p class="empet-text">您还未申请任何解债业务</p>
            <div @click.stop="grasp(3,$event)" class="server">
              <span>点我了解什么是债权人</span>
              <img src="../../../assets/debtor/righticon.png" alt="">
            </div>
            <van-button round type="info" size="large" @click="applyDebt">申请解债</van-button>
            <div class="creditor-contact-service" @click="chat">
              <span>遇到问题？</span>
              <span>联系客服，为您解答</span>
              <img src="../../../assets/debtor/right-arrow.png" alt="">
            </div>
          </div>
        </div>

      </van-list>
    </van-pull-refresh>
    <van-popup v-model="show1">
      <div class="grasp-debtor-box">
        <div class="title">{{show1Title}}</div>
        <div class="tips content" v-html="content1"></div>
        <p class="call-service content" @click="chat">点此联系解债业务客服></p>
        <div @click="show1 = false" class="van-hairline--top btn">知道了</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
  import navBar from "../components/navBar";
  export default {
    name: "debtorView",
    data() {
      return {
        list: [],
        info: {}, //基本信息
        loading: false,
        finished: false,
        refreshing: false,
        error: false,
        page: 0,
        pageSize: 10,
        pullStyle: {
          height: '500px'
        },
        show1: false,
        content1: '',
        show1Title: '债务人',
        agentLevel: '',
        agentimg: require('@/assets/debtor/actver.png'),
        reloadgrayicon: require('@/assets/debt/reload-gray-icon.png'),
      };
    },
    created() {
      if (this.$route.query.token) {
        this.$api.setToken(this.$route.query.token);

      }
    },
    components: {
      navBar,
    },
    computed: {
      navBarRightText() {
        return this.list.length ? '申请解债' : ''
      },
    },
    mounted() {
      this.pullStyle.height = document.body.clientHeight - (88 + 96 + 43 + 26) + 'px'
    },
    methods: {
      grasp(id, e) {
        e.stopPropagation()
        this.show1 = true;
        this.content1 = '';
        this.$api.post('debt/member/setting/get-content-setting', {
            id: id
          })
          .then((data) => {
            this.content1 = data.details
            this.show1Title = data.title
          })
      },
      refreshList() {
        if (!this.refreshing) {
          this.refreshing = true
          this.page = 0;
          this.onLoad();
        }
      },
      //联系客服跳原生
      chat() {
        this.showDialog = false
        this.params('18', '18', 'customerService')
      },
      applyDebt() {
        this.$router.push('/debtRelief/solutionDebtInfoCreditor')
      },
      onLoad() {
        this.page++;
        this.getInfo();
      },
      onRefresh() {
        this.page = 0;
        this.onLoad();
      },
      getInfo() {
        this.$api
          .post("/debt/member/creditor/creditor-order/lists", {
            page: this.page,
            size: this.pageSize,
          })
          .then((res) => {
            this.info = res;
            const widths = res.withs.data;
            if (this.refreshing) {
              this.list = [];
              this.finished = false;
            }
            for (let i in widths) {
              widths[i].amount = (parseFloat(widths[i].amount) + parseFloat(widths[i].interest_amount)).toFixed(2)
              // widths[i].amount = (parseFloat(widths[i].amount)).toFixed(2)
              // (parseFloat(widths[i].amount) * 1000000000000 +
              //   parseFloat(widths[i].interest_amount) * 1000000000000) /
              // 1000000000000;

              switch (widths[i].status) {
                case 10:
                  widths[i].status = "待债权人确认";
                  break;
                case 13:
                  widths[i].status = "待债务人确认";
                  break;
                case 20:
                  widths[i].status = "待债权人上传借据凭证";
                  break;
                case 23:
                  widths[i].status = "待债务人上传打款凭证";
                  break;
                case 25:
                  widths[i].status = "待平台审核";
                  break;
                case 30:
                  widths[i].status = "待财务审核";
                  break;
                case 40:
                  widths[i].status = "待合同审批";
                  break;
                case 50: // 0 都没签  1 债权人已签  2债务人已签   债务人和债权人不分先后
                  if (widths[i].sign_role !== 2) {
                    widths[i].status = "待合同签名";
                  } else {
                    widths[i].status = "待合同签名";
                  }
                  break;
                case 60:
                  widths[i].percentage = (parseFloat(widths[i].repayment_money) / widths[i].amount).toFixed(2) * 100
                  widths[i].status = "债权回收中";

                  if (widths[i].repayment_status == 2) {
                    widths[i].status = '冻结中'
                  }
                  if (parseInt(widths[i].repayment_period) >= 0) {
                    widths[i]._showProgress = true
                  }
                  break;
                case 70:
                  widths[i].status = "债权人驳回";
                  break;
                case 75:
                  widths[i].status = "债务人驳回";
                  break;
                case 80:
                  widths[i].status = "平台驳回";
                  break;
                case 85:
                  widths[i].status = "财务驳回";
                  break;
                case 90:
                  widths[i].status = "合同审批驳回";
                  break;
                case 100:
                  widths[i].status = "合同撤回";
                  break;
                case 110:
                  widths[i].status = "合同失效";
                  break;
                case 120:
                  widths[i].status = "合同作废";
                  break;
                case 130:
                  widths[i].status = "债权回收完成";
                  break;
                default:
                  widths[i].status = "订单状态异常";
              }

              this.list.push(widths[i]);
            }
            if (this.list.length === 0 || widths.length === 0) {
              this.finished = true;
              this.loading = false;
              this.refreshing = false;
              return;
            }

            this.loading = false;
            if (res.withs.current_page === res.withs.last_page) {
              this.finished = true;
            }

            if (this.refreshing) {
              this.$toast("刷新成功");
              this.refreshing = false;
            }

            if (!this.finished && !this.loading && this.list.length <= 2) {
              this.onLoad();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.finished = true;
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            //this.$toast(message);
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            }
            return;
          });
      },
      //订单详情
      handleCreditor(item) {
        this.$router.push({
          path: "/creditor/detail",
          query: {
            order_id: item.id,
            debtor_id: item.debtor_id,
            is_supplement: item.is_supplement,
            debt_from: 'list',
          },
        });
      },
      goBack() {
        this.$router.push({
          path: '/debtRelief/wrDebtPersonHome',
          query: {
            token: localStorage.getItem('_token') || this.$route.query.token,
          },
        })
        // this.$router.go(-1)
      },
    },
  };
</script>
<style lang="less">
  .creditorView_warpper {
    &::-webkit-scrollbar {
      display: none;
    }

    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;

    padding-top: 88px;
    box-sizing: border-box;
    background-color: #f5f6f7;
    min-height: 100%;
    color: #333;
    font-size: 14px;

    // .navbar {
    //   margin: 24px 5px 0 5px;
    // }
    .contentBox {
      margin-top: 12px;
      background: #fff;

      .contentBox-box {
        display: flex;
        align-items: center;

        .left-img {
          width: 42px;
          height: 42px;
          margin: 21px 12px;

          img {
            width: 100%;
            height: 100%;
            border-radius: 25px;
          }
        }

        .right {
          margin: 19px 0 18px;

          .title {
            height: 26px;
            font-size: 16px;
            font-weight: 600;
            line-height: 26px;
          }

          .desc {
            height: 21px;
            font-size: 13px;
            color: #999999;
            line-height: 21px;
          }
        }
      }
    }

    .creditor-contact-service {
      padding: 9px 12px 12px;
      display: flex;
      align-items: center;

      :nth-of-type(1) {
        height: 22px;
        font-size: 14px;
        color: #999999;
        line-height: 22px;
      }

      :nth-of-type(2) {
        height: 22px;
        font-size: 14px;
        color: #666666;
        line-height: 22px;
        margin-right: 6px;
      }

      img {
        width: 10px;
        height: 13px !important;
      }
    }

    p {
      height: 26px;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      line-height: 26px;
      padding: 0 12px;
    }

    .van-cell {
      padding: 0;
      line-height: normal;
      background-color: #f5f6f7;
    }

    .dataBody {
      background-color: #fff;
      margin: 12px 0 0;

      .debtor_information {
        padding: 12px 12px 15px;

        .status-box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;

          .color_org {
            color: #f9591b;
            font-weight: 600;
            font-size: 16px;
            width: 100%;
            padding-bottom: 12px;
            margin-bottom: 15px;
            border-bottom: 1px solid #eeeeee;
          }

          .color_999 {
            color: #999;
            font-weight: 600;
            font-size: 16px;
            width: 100%;
            padding-bottom: 12px;
            margin-bottom: 15px;
            border-bottom: 1px solid #eeeeee;
          }

          .status-box-right {
            background: #FC740C;
            border-radius: 16px;
            text-align: center;
            padding: 4px 12px;
            position: absolute;
            top: -7px;
            right: 0;

            span {
              height: 24px;
              font-size: 15px;
              font-weight: 500;
              color: #FFFFFF;
              line-height: 24px;
            }
          }
        }

        .title {
          font-weight: 600;
          font-size: 16px;
          width: 100%;
          padding-bottom: 12px;
          margin-bottom: 15px;
          border-bottom: 1px solid #eeeeee;
        }

        .creditorsIcon {
          // margin-right: 9px;
          margin-bottom: 13px;
          float: left;

          img {
            border-radius: 30px;
          }
        }

        .creditorsName {
          margin-left: 9px;
          float: left;
          line-height: 27px;
          margin-bottom: 13px;
        }

        .clearBoth {
          clear: both;
        }

        .solutionMoney {
          margin: 12px 0;
          padding-left: 0px;
        }

        .creditorsMoney {
          font-weight: 600;
          font-size: 24px;
          padding-left: 0px;
        }

        .creditorsMoney1 {
          font-weight: 600;
          font-size: 24px;
          margin-bottom: 12px;
        }

        .agent {
          color: #ccc;
          margin: 12px 0 0;
          padding-left: 0px;
        }
      }

      .progress {
        margin: 12px 0 15px;
      }
    }

    .empty {
      width: 100%;
      margin-top: 42px;

      .emptyMsg {
        text-align: center;
        width: 100%;
        height: 100%;

        .empet-text {
          height: 26px;
          font-size: 16px;
          font-weight: 600;
          color: #333333;
          line-height: 26px;
          margin-bottom: 5px;
        }

        .server {
          display: flex;
          align-items: center;
          width: fit-content;
          margin: 0 auto 42px;

          span {
            height: 21px;
            font-size: 13px;
            color: #2A62FC;
            line-height: 21px;
            margin-right: 8px;
          }

          img {
            width: 6px;
            height: 10px;
          }
        }

        .van-button--large {
          width: calc(100% - 54px);
        }

        .van-button--info {
          background-color: #FC740C;
          border: 1px solid #FC740C;

          .van-button__text {
            height: 28px;
            font-size: 17px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 28px;
          }
        }


        .creditor-contact-service {
          margin-top: 18px;
          display: flex;
          align-items: center;
          justify-content: center;

          :nth-of-type(1) {
            height: 22px;
            font-size: 14px;
            color: #999999;
            line-height: 22px;
          }

          :nth-of-type(2) {
            height: 22px;
            font-size: 14px;
            color: #666666;
            line-height: 22px;
            margin-right: 6px;
          }

          img {
            width: 10px;
            height: 13px !important;
          }
        }
      }
    }

    .loading {
      width: 100%;
      /*padding-top: 100px;*/
      text-align: center;

      img {
        width: 35%;
        margin-top: 50%;
      }
    }

    .van-pull-refresh {
      &::-webkit-scrollbar {
        display: none;
      }

      overflow-y: scroll;
    }


  }

  .van-popup--center {

    width: calc(100% - 67px);
    border-radius: 10px;

    .grasp-debtor-box {
      padding: 20px 21px 0;

      .title {
        width: 100%;
        text-align: center;
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        line-height: 25px;
        margin-bottom: 8px;
      }

      .content {
        font-size: 15px;
        color: #333333;
        line-height: 24px;
      }

      .tips {
        p {
          height: initial;
          padding: 0;
          color: rgb(17, 31, 44) !important;
          font-weight: initial;
        }
      }

      .call-service {
        color: #2A62FC;
        margin-bottom: 18px;
        padding: 0;
        font-weight: initial;
      }

      .btn {
        width: 100%;
        height: 28px;
        font-size: 17px;
        font-weight: 700;
        color: #F9591B;
        line-height: 28px;
        padding: 11px 0;
        width: 100%;
        text-align: center;
      }
    }

  }

  .creditor-first-fiv {
    position: relative;

    .refresh-btn {
      position: absolute;
      right: 12px;
      bottom: 2px;
      width: 24px;
      height: 24px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>